import { useState } from "react";
import "./ManageWebsiteModal.scss";
import { MiniCancelIconSVG } from "../../utils/svgIcons";
import { redirectToDashy } from "../../../../Utils/common";
import { BRAND_WEBSITE_BUSINESS_CATEGORIES, EXPLORE_THEME_ROUTE } from "../../../../Constants/routesConstant";
import { getAuthToken } from "../../../../Utils/authToken";
import { QUERY_PARAM_AUTH } from "../../../../Utils/constants";
import { TRACKING_EVENTS } from "../../../../Utils/GAEvents/gaEventsConstants";
export const ManageWebsiteModal = (props) => {
  const { sendPostPurchaseDataToGAEvent } = props;
  const [checkboxState, setCheckboxState] = useState({
    checkbox1: false,
    checkbox2: false,
  });
  const handleCheckboxChange = (checkboxName) => {
    setCheckboxState((prevState) => ({
      ...prevState,
      [checkboxName]: !prevState[checkboxName],
    }));
  };
  const handleCTAClick = () => {
    if (!checkboxState.checkbox1 && !checkboxState?.checkbox2) {
      return;
    }
    if (checkboxState?.checkbox1 && checkboxState?.checkbox2) {
      sendPostPurchaseDataToGAEvent(TRACKING_EVENTS.postPurchaseGetWebsiteClicked, { dimension6: "both" });
      redirectToDashy(`${EXPLORE_THEME_ROUTE}`);
    } else if (checkboxState?.checkbox1) {
      sendPostPurchaseDataToGAEvent(TRACKING_EVENTS.postPurchaseGetWebsiteClicked, { dimension6: "ecommerce" });
      redirectToDashy(`${EXPLORE_THEME_ROUTE}`);
    } else if (checkboxState?.checkbox2) {
      sendPostPurchaseDataToGAEvent(TRACKING_EVENTS.postPurchaseGetWebsiteClicked, { dimension6: "brand" });
      redirectToDashy(`${BRAND_WEBSITE_BUSINESS_CATEGORIES}`);
    }
  };
  return (
    <div className="overLay_container">
      <div className="manage_website_container">
        <div className="top_container">
          <div className="first_top_container">
            <p className="primary_text">What kind of website do you want?</p>
            <p className="secondary_text">This helps us provide relevant recommendations for website</p>
          </div>
          <div className="first_bottom_container">
            <div className="first_box">
              <input
                type="checkbox"
                checked={checkboxState.checkbox1}
                onChange={(e) => {
                  e.stopPropagation();
                  handleCheckboxChange("checkbox1");
                }}
              />
              <div className="checkbox_text" onClick={() => handleCheckboxChange("checkbox1")}>
                <p className="primary">To sell services or products</p>
                <p className="secondary">For online stores, to take appointments or bookings</p>
              </div>
            </div>
            <div className="second_box">
              <input
                type="checkbox"
                checked={checkboxState.checkbox2}
                onChange={(e) => {
                  e.stopPropagation();
                  handleCheckboxChange("checkbox2");
                }}
              />
              <div className="checkbox_text" onClick={() => handleCheckboxChange("checkbox2")}>
                <p className="primary">To showcase work or business</p>
                <p className="secondary">For business website, personal brand, blog, portfolio, consultant, etc</p>
              </div>
            </div>
          </div>
        </div>
        <button
          className="modal_cta"
          onClick={handleCTAClick}
          style={
            !checkboxState?.checkbox1 && !checkboxState?.checkbox2
              ? { pointerEvents: "none", cursor: "not-allowed", background: "#E9E9E9" }
              : null
          }
        >
          Continue
        </button>
        <span onClick={() => props?.handleCloseManageDomain && props?.handleCloseManageDomain()}>
          <MiniCancelIconSVG />
        </span>
      </div>
    </div>
  );
};
